const Component = () => import('./Brand');

export { Component };
